import axios from "axios"
import Cookies from 'js-cookie'

export default defineNuxtPlugin((NuxtApp) => {
    const runtimeConfig = useRuntimeConfig();

    const BACKEND_URL = runtimeConfig.public.API_URL

    axios.defaults.baseURL = BACKEND_URL
    axios.defaults.withCredentials = false;
    axios.defaults.proxyHeaders = false;
    if(process.client){
        const token = Cookies.get('token');
        if(token){
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        }
    }

    axios.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response?.status === 401 && process.client) {
                Cookies.remove('token')
                Cookies.remove('user')
                delete axios.defaults.headers.common['Authorization']
                navigateTo('/auth/login')
            }
            return Promise.reject(error)
        }
    )

    return {
        provide: { 
            axios: axios
        },
    }
})